export interface UserRegistrationResponseModel {
  data: { email: string; userApiKey: string };
  meta: { requirePhoneNumberConfirmation: boolean; country: string };
  success:boolean
}
